<template>
	<dms-edit-layout v-bind="layoutProps">
		<dms-row>
				<!--        TODO: TP - upravit label -->
				<dms-card  header-localization-key="NHodSzb">
					<dms-col :md="6" :sm="12" :xs="24">
						<dms-select :value.sync="VyrobekvozOzn" :select-list="dropdownList.VyrobekvozOzn" label-key="VYROBEKVOZ_OZN"
							@update:value="clearSelect" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
						<tabulkova-pozice-select ref="TabulkovaPoziceSelect" :value.sync="Tablpozice" :text.sync="TablpoziceText"
							:filter="{ VyrobekvozOzn: VyrobekvozOzn }" :mutation-name="mutationsMappers.tabulkovaPozice" label-key-text="TABLPOZICE" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
						<dms-input-number :value.sync="HodSzbNahr" label-key="HOD_SZB_NAHR" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
						<dms-input-number :value.sync="HodSzbNahr1" label-key="HOD_SZB_NAHR1" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
						<dms-input-number :value.sync="HodSzbNahr2" label-key="HOD_SZB_NAHR2" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
						<dms-input-number :value.sync="HodSzbNahr8" label-key="HOD_SZB_NAHR8" />
					</dms-col>
				</dms-card>
		</dms-row>
	</dms-edit-layout>
</template>

<script>
import { editFactory } from '@/main/pages';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				tabulkovaPozice: `${this.storeUri}/${editMutations.NAHRADNI_SAZBA_TABULKOVA_POZICE_SELECT_MAPPER}`,
			};
		},
	},
	methods: {
		clearSelect() {
			this.$refs.TabulkovaPoziceSelect.clear();
		},
	},
});
</script>
